// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Counter_wrapper__1lvs0","button":"Counter_button__1TkN1"};